import { MenuItem, Select } from "@mui/material";
import type { GridRenderEditCellParams } from "@mui/x-data-grid-premium";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type { DecisionBehaviorOfSubitems } from "../../../../clients/graphqlTypes.js";

export const DataGridDecisionBehaviorCell = ({
  id,
  field,
  value,
  api,
}: GridRenderEditCellParams) => {
  const { t } = useTranslate("Decisions");
  const [isOpen, setIsOpen] = React.useState(true);

  const currentValue = value as DecisionBehaviorOfSubitems;

  const options: { value: DecisionBehaviorOfSubitems; label: string }[] = [
    ...(currentValue === "NONE"
      ? [{ value: "NONE" as const, label: t("NONE", { ns: "Decisions" }) }]
      : []),
    { value: "SELECT_MANY", label: t("SELECT_MANY", { ns: "Decisions" }) },
    { value: "SELECT_ONE", label: t("SELECT_ONE", { ns: "Decisions" }) },
  ];

  const handleChange = React.useCallback(
    (newValue: DecisionBehaviorOfSubitems) => {
      api.setEditCellValue({ id, field, value: newValue });
      api.stopCellEditMode({ id, field });
    },
    [id, field, api]
  );

  return (
    <Select
      value={currentValue ?? ""}
      onChange={e => handleChange(e.target.value as DecisionBehaviorOfSubitems)}
      size="extra-small"
      fullWidth
      autoFocus
      open={isOpen}
      onClose={() => setIsOpen(false)}
      onBlur={() => {
        setIsOpen(false);
        api.stopCellEditMode({ id, field });
      }}
      variant="outlined"
      sx={{ "& fieldset": { border: "none" } }}
      onKeyDown={e => {
        if (e.key === "Enter") api.stopCellEditMode({ id, field });
        else if (e.key === "Escape")
          api.stopCellEditMode({ id, field, ignoreModifications: true });
      }}
    >
      {options.map(opt => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  );
};
